import CreekShow from '../components/Show';
import CreekPageShows from '../components/PageShows';
import CreekPageShowsAll from '../components/PageShowsAll';
import CreekPageShowsCalendar from '../components/PageShowsCalendar';
import CreekPageShow from '../components/PageShowDynamic';
// import CreekPageShow from '../components/PageShow';
import CreekPageBroadcast from '../components/PageBroadcastDynamic';
// import CreekPageBroadcast from '../components/PageBroadcast';
import CreekPageBroadcastPlayer from '../components/PageBroadcastPlayer';

const CreekShowsPlugin = {

  install(Vue, options) {

    var _scope = window.top.document;

    // Add Components
    Vue.component(CreekShow.name, CreekShow);

    // Add router if needed
    // if(typeof options.router != "undefined" && typeof Vue.router == "undefined"){
    //   console.log("Added Router");
    //   router = new options.router;
    //   Vue.use(options.router);
    // }

    // Add Routes to Router
    options.router.addRoutes([
      {
        path: _scope.Creek.config.shows.router.baseRoutePath + '/weekday/:weekdayNumber',
        component: CreekPageShows
      },
      {
        path: _scope.Creek.config.shows.router.baseRoutePath + '/',
        component: CreekPageShows
      },
      {
        path: _scope.Creek.config.shows.router.baseRoutePath + '/shows',
        component: CreekPageShows
      },
      {
        path: _scope.Creek.config.shows.router.baseRoutePath + '/profiles/:username',
        component: CreekPageShowsAll
      },
      // {
      //   path: _scope.Creek.config.shows.router.baseRoutePath + '/broadcasts/:broadcastID',
      //   component: CreekPageBroadcast
      // },
      {
        path: _scope.Creek.config.shows.router.baseRoutePath + '/broadcasts/:broadcastID',
        component: CreekPageBroadcastPlayer
      },
      {
        path: _scope.Creek.config.shows.router.baseRoutePath + '/shows/broadcasts/:broadcastID',
        component: CreekPageBroadcastPlayer
      },
      {
        path: _scope.Creek.config.shows.router.baseRoutePath + '/schedule',
        component: CreekPageShowsCalendar
      },
      {
        path: _scope.Creek.config.shows.router.baseRoutePath + '/calendar',
        component: CreekPageShowsCalendar
      },
      {
        path: _scope.Creek.config.shows.router.baseRoutePath + '/all',
        component: CreekPageShowsAll
      },
      {
        path: '/shows/:short_name',
        component: CreekPageShow
      },
      {
        path: '/:short_name',
        component: CreekPageShow
      },
    ]);

  }

};

export default CreekShowsPlugin;
